export const NETWORK_IDS = [
    "vodafone",
    "ee",
    "o2",
    "three",
    "o2Plan",
    "eePlan",
];
export const isNetworkId = (value) => NETWORK_IDS.includes(value);
export const normalizeNetworkId = (value) => {
    const normalized = value === "EEPlan" ? "eePlan" : value;
    return isNetworkId(normalized) ? normalized : null;
};
export const reverseNormalizeNetworkId = (value) => {
    return value === "eePlan" ? "EEPlan" : value;
};
